import handleUnAuthorizedError from './handleUnAuthorizedError';

export default function responseInterceptor(api) {
  api.interceptors.response.use(
    (res) => res,
    async (error) => {
      if (!error.response) {
        return Promise.reject(error);
      }
      switch (error.response.status) {
        case 401:
          return handleUnAuthorizedError(error);
        default:
          return Promise.reject(error);
      }
    },
  );
}
